import * as token from "@universityofmaryland/web-token-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { combineStyles } from "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/events";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-icons-library/controls";
import { createCompositeCarouselFullScreen } from "./full-screen.js";
import "@universityofmaryland/web-styles-library";
import { createLayoutImageContainer } from "../../../layout/image.js";
import { createCompositeCarouselImage } from "./image.js";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "../../../atomic/animations/brand/card-stack.js";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
const CreateOverlaySlide = ({
  images,
  isToggleCaption
}) => images.map((image) => {
  const imageBlock = createLayoutImageContainer({ image, showCaption: true, isToggleCaption });
  const imageContainerModel = new ElementBuilder().withClassName("carousel-overlay-container").withStyles({
    element: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: token.color.gray.dark,
      "& > *": {
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      "& img": {
        objectFit: "contain",
        maxHeight: "100%",
        maxWidth: "100%"
      }
    }
  }).withChild(imageBlock).build();
  return imageContainerModel;
});
const createCompositeCarouselOverlay = ({
  images,
  isToggleCaption = true
}) => (() => {
  let isFullScreenEvents = null;
  const setFullScreen = (index) => {
    let canMove = true;
    if (isFullScreenEvents) {
      window.removeEventListener("keyup", isFullScreenEvents);
    }
    overlayCarousel.events.EventMoveTo(index);
    setTimeout(() => fixedFullScreen.events.show(), 100);
    setTimeout(() => {
      overlayCarousel.events.EventResize();
    }, 100);
    const handleKeyup = (event) => {
      if (!canMove) return;
      canMove = false;
      if (event.key === "ArrowLeft") {
        overlayCarousel.events.EventSlideLeft();
      } else if (event.key === "ArrowRight") {
        overlayCarousel.events.EventSlideRight();
      }
      setTimeout(() => {
        canMove = true;
      }, 700);
    };
    isFullScreenEvents = handleKeyup;
    window.addEventListener("keyup", handleKeyup);
  };
  const overlaySlideModels = CreateOverlaySlide({ images, isToggleCaption });
  const overlaySlides = overlaySlideModels.map((model) => model.element);
  const firstSlide = overlaySlideModels[0];
  const slideStyles = firstSlide ? firstSlide.styles : "";
  const overlayCarousel = createCompositeCarouselImage({
    slides: overlaySlides,
    maxHeight: window.innerHeight / 10 * 8
  });
  const fixedFullScreen = createCompositeCarouselFullScreen({
    content: overlayCarousel.element,
    callback: () => {
      if (isFullScreenEvents) {
        window.removeEventListener("keyup", isFullScreenEvents);
      }
    }
  });
  return {
    element: fixedFullScreen.element,
    styles: combineStyles(
      slideStyles,
      overlayCarousel.styles,
      fixedFullScreen.styles
    ),
    events: {
      setFullScreen
    }
  };
})();
export {
  createCompositeCarouselOverlay
};
//# sourceMappingURL=overlay.js.map
